export * from './error-log'
export * from './countries'
export * from './chart-config'

import { ToastOptions, toast } from 'react-toastify'

export const toastOpts: ToastOptions = {
  position: 'bottom-left',
  autoClose: 2000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  theme: 'colored',
}

export const notify = {
  success: (msg: string) => toast.success(msg, toastOpts),
  error: (msg: string) => toast.error(msg, toastOpts),
}

export const validateEmail = (email: string) => {
  const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i
  return emailRegex.test(email)
}
